<template>
	<aside class="detail">
		<div class="detail-head"><div class="d-id"><div><div class="d-name">{{ title }}</div><div v-if="sub" class="d-sub">{{ sub }}</div></div></div><div v-if="savedAt" class="d-nav"><span class="yn inc">saved {{ savedAt }}</span></div></div>
		<div class="detail-body">
			<div class="price-big num">{{ money(annual) }} <span style="font-size:16px;font-weight:600;color:var(--muted)">a year</span></div>
			<div v-if="priceSub" class="price-sub">{{ priceSub }}</div>
			<div v-if="paysToday !== null" class="d-kv" style="margin-top:10px"><span>{{ todayLabel }}</span><b class="num">{{ money(paysToday) }} a year</b></div>
			<div v-if="change !== null" class="d-kv"><span>{{ changeLabel }}</span><b class="num" :class="{ good: change > 0, lost: change < 0 }">{{ signed(change) }} a year</b></div>
			<div v-if="totalWithToday !== null" class="d-kv"><span>With this quote</span><b class="num">{{ money(totalWithToday) }} a year</b></div>
			<div v-if="breakdown.length" class="d-section" style="margin-top:8px">
				<template v-for="(g, gi) in breakdown">
					<div :key="'g' + gi" class="bd-grp"><span v-if="brandClass(g.brand)" class="bdot" :class="brandClass(g.brand)"></span>{{ g.label || brandName(g.brand) }}</div>
					<div v-for="(r, ri) in g.rows" :key="gi + ':' + ri" class="bd-row" :class="{ inc: r.included }"><span>{{ r.label }}</span><b v-if="r.included">included</b><b v-else>{{ money(r.amount) }}{{ r.once ? ' once' : '' }}</b></div>
				</template>
			</div>
			<pe-verdict v-if="verdict" :tone="verdict.tone" :title="verdict.title" :text="verdict.text"></pe-verdict>
			<slot name="actions"></slot>
			<p v-if="footnote" class="sub-hint" style="text-align:center">{{ footnote }}</p>
		</div>
	</aside>
</template>

<script>
import PeVerdict from './PeVerdict.vue'
import { brandKey, BRAND_NAMES } from './PeBrandChip.vue'
import { money, signed } from './money.js'

export default {
	name: 'PePriceRail',
	components: { PeVerdict },
	props: {
		title: { type: String, default: 'Your quote' },
		sub: { type: String, default: '' },
		annual: { type: Number, default: 0 }, // every amount is integer cents
		oneTime: { type: Number, default: 0 },
		monthly: { type: Number, default: 0 },
		paysToday: { type: Number, default: null },
		todayLabel: { type: String, default: 'They pay today' },
		change: { type: Number, default: null }, // what replaces today's amount: the difference
		changeLabel: { type: String, default: 'Change' },
		totalWithToday: { type: Number, default: null }, // what comes on top of today's amount: the new total
		breakdown: { type: Array, default: () => [] }, // [{ brand, label?, rows: [{ label, amount, included, once? }] }]
		verdict: { type: Object, default: null }, // { tone, title, text }
		savedAt: { type: String, default: '' },
		footnote: { type: String, default: '' },
	},
	computed: {
		priceSub() {
			const parts = []
			if (this.oneTime) parts.push('+ ' + money(this.oneTime) + ' once')
			if (this.monthly) parts.push(money(this.monthly) + ' a month')
			return parts.join(' · ')
		},
	},
	methods: {
		money,
		signed,
		brandClass(brand) { return brandKey(brand).toLowerCase() },
		brandName(brand) { return BRAND_NAMES[brandKey(brand)] || brand || '' },
	},
}
</script>
